var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputarea-container"},[_c('textarea',{ref:"input",staticClass:"padding-sm",class:[_vm.customClasses],attrs:{"placeholder":_vm.$props.placeholder,"disabeld":_vm.$props.disabled},domProps:{"value":_vm.inputValue},on:{"input":_vm.keyPressing}})])
}
var staticRenderFns = []

export { render, staticRenderFns }